import React from "react";
import { formatString } from "../helper-components/helper-function";

function InvoiceStatus({ status }) {
  if (status === "pending") {
    return (
      <div
        className={`border border-[var(--status-badge-red-border)] bg-[var(--status-badge-red-bg)] text-[var(--status-badge-red-fg)]  text-[length:--create-table-row-font-size] font-[var(--create-table-batch-con-fw)] border-radius px-2 py-1 w-fit`}
      >
        {formatString(status)}
      </div>
    );
  } else return <></>;
}

export default InvoiceStatus;
